var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.668,
    height: 18.516,
    viewBox: "0 0 15.668 18.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-notifications-outline",
    "data-name": "Icon ionic-md-notifications-outline",
    d: "M13.5,6.6a6.435,6.435,0,0,1,1.064.2,4.536,4.536,0,0,1,3.457,4.444v5.68l.415.417.347.348H8.131l.347-.348.415-.417v-5.68A4.536,4.536,0,0,1,12.35,6.8a7.88,7.88,0,0,1,1.064-.2m.045-3.226a1.361,1.361,0,0,0-1.382,1.389v.648a6,6,0,0,0-4.608,5.833v5.092L5.625,18.188v.926H21.293v-.926L19.45,16.336V11.244a6,6,0,0,0-4.608-5.833V4.764a1.361,1.361,0,0,0-1.382-1.389ZM15.3,20.04H11.616a1.843,1.843,0,1,0,3.687,0Z",
    transform: "translate(-5.625 -3.375)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.65497c0950e836d0b9d95f9607480de6.svg";
export { ForwardRef as ReactComponent };